import {
  append,
  compose,
  eqProps,
  groupWith,
  ifElse,
  length,
  map,
  mergeAll,
  pick,
  pluck,
  prop,
  propEq,
  propOr,
  sortBy,
  uniq,
} from 'ramda';

import { formatId } from '../../../../helpers/charts';
import { clear, compact, path } from '../../../../helpers/compact';

const items = propOr([], 'items');
export const getColorScale = compose(uniq, pluck('color'), items);

const legend = pick(['legend']);
const withColor = pick(['legend', 'color']);
const hasColored = propEq('colored', 'oui');
const picks = ifElse(hasColored, withColor, legend);
export const getLegends = compose(clear, uniq, map(picks), items);

/******** BAR ********/
export const tickFormat = (data) => [
  path('primary.year1', data),
  path('primary.year2', data),
];

const formatTotalAmount = (data) => [
  path('primary.amount1', data),
  path('primary.amount2', data),
];
const sortTotalAmount = (data) => [
  [{ quarter: 1, earnings: 1, label: prop(0, data) }],
  [{ quarter: 1, earnings: 1, label: prop(1, data) }],
];
export const totalAmount = compose(sortTotalAmount, formatTotalAmount);

export const getColorScaleAppend = compose(
  append('transparent'),
  getColorScale
);

const addArray = (o) => [o];
const format = (o) => ({
  ...o,
  quarter: 1,
  earnings: Number(o.amount),
  offset: o.offset && Math.abs(o.offset) !== 0 ? Number(o.offset) * -1 : 0,
});
const getBar = compose(
  addArray,
  pick(['quarter', 'earnings', 'offset', 'label']),
  format
);
const sortPosition = compose(map(getBar), sortBy(prop('position')));

const getyear = compose(formatId, prop('year'), prop(0));

const objectedYear = (data) => ({
  [getyear(data)]: sortPosition(data),
});

export const getBarsSorted = compose(
  mergeAll,
  map(objectedYear),
  groupWith(eqProps('year')),
  sortBy(prop('year')),
  items
);

/******** PIE ********/
const itemsLength = compose(length, items);
export const multiple = (data) => itemsLength(data) > 1;

const number = prop('number');
const formatPie = (d) =>
  compact({
    ...d,
    number: Number(number(d)), // TODO si number(d) = 0, num == false...,
  });

const sublabel = prop('sublabel');
const addSublabel = (data) => {
  const d = prop(0, data);
  if (!multiple(data) && sublabel(d)) {
    data.push({ label: sublabel(d), number: number(d) });
    data[0].number = 0;
  }
  return data;
};
const formattedPie = compose(
  formatPie,
  pick(['number', 'label', 'sublabel', 'legend'])
);
const formatPies = (data) => map(formattedPie, items(data));
const getFormattedPies = compose(addSublabel, formatPies);
export const getPies = (data) => getFormattedPies(data);
